module.exports = __webpack_public_path__ + "static/media/ribbon-left.5acc5d80.svg";